export default __webpack_public_path__ + "static/sixer-logo-footer-22d0bbfc80d233eab65cd59e55cae331.svg";